module.exports = __webpack_public_path__ + "img/blezux.23eed67f.svg";